/**
 * Created by Kevin Dench on 11/2/2016.
 */
/* @ngInject */
export default function DocFinderFileService(UniquePartApiService, __env) {
    const NTPrefix = 'NT_';
    const KEMPrefix = 'KEMET_';
    const docFinderURL = 'http://www.kemet.com/docfinder';
    let lang = 'en';
    let country = 'US';
    if ('JAPANESE' === __env.language) {
        lang = 'ja';
        country = 'JP';
    }
    const service = {
        buildQueryString: function (queryData) {
            const query = [];
            for (let d in queryData) {
                if (queryData.hasOwnProperty(d)) {
                    query.push(encodeURIComponent(d) + '=' + encodeURIComponent(queryData[d]));
                }
            }
            return '?' + query.join('&');
        },
        getPrefix: function (result, pn) {
            if (result.value.startsWith('TOKIN')) {
                return NTPrefix + pn;
            }
            return KEMPrefix + pn;
        },
        /**
         * Build the Docfinder URL using the Unique Part Parameter Values
         *
         * This function will query the rest API, and using the Parameter Values it gets back, it will check for the
         * `paramNam` that's passed in
         *
         * @param uniquePart  The Unique PN with which we're retrieving Parameter Values.
         * @param paramName Parameter Name to search for.
         * @param callBack  The callback that gets passed the final query string
         *
         * @internal getPrefix
         * @internal buildQueryString
         *
         * @returns {*}
         */
        buildRohsUrl: function (uniquePart, paramName, callBack) {
            // We _have_ to return the result of UniquePartApiService.getParameterValues()
            return UniquePartApiService.getParameterValues(uniquePart.uniquePn, function (results) {
                // Set up the variables
                let keyExists = false;
                const query = {Partnumber: ''};

                for (var i = 0; i < results.length; i++) {
                    if (results[i].parameterName === paramName) {
                        // set the empty string for the query.
                        query.Partnumber = service.getPrefix(results[i], uniquePart.displayPn);
                        // We know the `paramName` key exists
                        keyExists = true;
                        callBack(docFinderURL + service.buildQueryString(query));
                        break;
                    }
                }
                // If the `paramName` didn't exist, we need to handle that.
                if (!keyExists) {
                    // set the empty string for the query
                    query.Partnumber = KEMPrefix + uniquePart.displayPn;
                    callBack(docFinderURL + service.buildQueryString(query));
                }
            });
        },
        buildDataSheetUrl: function (uniquePart) {
            if (uniquePart != null && uniquePart.parameterValues != null) {
                for (var i = 0; i < uniquePart.parameterValues.length; i++) {
                    if (uniquePart.parameterValues[i].parameterName === 'Datasheet') {
                        return `${__env.datasheetUrl}${encodeURIComponent(uniquePart.parameterValues[i].value)}.pdf`;
                    }
                }
            }
        },
        buildStepUrl: function (uniquePn) {
            return `${__env.documentationUrl}download/step/${encodeURIComponent( uniquePn )}.step`;
        },
        buildIntelliSpecUrl( uniquePn ) {
            return `${__env.documentationUrl}download/specsheet/${encodeURIComponent( uniquePn )}`;
        },
        buildIntelliSpecProUrl( uniquePn ) {
            return `${__env.documentationUrl}download/specsheet/${encodeURIComponent( uniquePn )}?lang=${lang}&country=${country}`;
        }
    };
    return service;
}
